import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, EventEmitter, computed, input } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { EnabledPipe } from "../../../helpers/enabledpipe/enabledpipe";
import { SelfServiceCommandKeys } from "../../../helpers/enums/selfServiceCommands";
import { StartLoadMessage } from "../../../helpers/self-service/models/types";
import { ModifyGracefulRestartCommand } from "../../../helpers/self-service/modify_graceful_restart";
import { SelfServiceCommand } from "../../../helpers/self-service/self-service-command";
import { IpBgpSubscriptionDetails } from "../../../pages/subscription-detail/types";
import { SelfserviceWizard } from "../selfservice-wizard/selfservice-wizard";

type IpBgpSap = IpBgpSubscriptionDetails["saps"][number];

@Component({
  selector: "selfservice-graceful-restart",
  templateUrl: "selfservice-graceful-restart.html",
  styleUrl: "selfservice-graceful-restart.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, EnabledPipe, FormsModule, SelfserviceWizard, TranslatePipe],
})
export class SelfserviceGracefulRestart {
  subscription = input.required<IpBgpSubscriptionDetails>();
  instance = input.required<IpBgpSap>();
  sapIndex = input.required<number>();
  bus = input.required<EventEmitter<StartLoadMessage>>();

  protected gracefulRestart = computed(() => this.instance().gracefulRestart ?? false);
  protected newSetting = computed(() => !this.gracefulRestart());

  protected readonly buildCommand = () => {
    const action = SelfServiceCommandKeys.ModifyGracefulRestart;
    const modify = new ModifyGracefulRestartCommand();
    modify.setForInstance(this.instance().subscriptionInstanceId, this.newSetting());
    const command = new SelfServiceCommand(this.subscription().subscriptionId, action);
    command.payload = modify;
    return { command, action };
  };
}
